import { render, staticRenderFns } from "./resume-tags-view.vue?vue&type=template&id=561876fb&"
import script from "./resume-tags-view.vue?vue&type=script&lang=js&"
export * from "./resume-tags-view.vue?vue&type=script&lang=js&"
import style0 from "./resume-tags-view.vue?vue&type=style&index=0&id=561876fb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports